import React from 'react';
import ReactDOM from 'react-dom/client';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap';
import 'popper.js';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
